export default "__VITE_ASSET__826fa17c__"